import { render, staticRenderFns } from "./AdminInfos.vue?vue&type=template&id=7089f306&scoped=true"
import script from "./AdminInfos.vue?vue&type=script&lang=js"
export * from "./AdminInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7089f306",
  null
  
)

export default component.exports